import _ from "lodash";
import { DATA_GRID_COLUMN_TYPES } from "StandardsTable/modules/constants";
import {
  ELEMENT_TYPE_MYP_LEARNING_STANDARD,
  ELEMENT_TYPE_UBD_LEARNING_STANDARD,
  ELEMENT_TYPE_DP_LEARNING_STANDARD,
  ELEMENT_TYPE_PYP_LEARNING_STANDARD,
} from "Constants/stringConstants";
import { buildSearchFlatTree as buildSearchFlatTreeWithBoldTags } from "Utils";

export const getColumnIdsToDisplay = ({ plannerElementType }) => {
  const columnIdsToDisplay = [
    DATA_GRID_COLUMN_TYPES.SELECTION,
    DATA_GRID_COLUMN_TYPES.TITLE,
  ];

  switch (plannerElementType) {
    case ELEMENT_TYPE_MYP_LEARNING_STANDARD:
    case ELEMENT_TYPE_DP_LEARNING_STANDARD:
    case ELEMENT_TYPE_UBD_LEARNING_STANDARD:
    case ELEMENT_TYPE_PYP_LEARNING_STANDARD:
      columnIdsToDisplay.push(DATA_GRID_COLUMN_TYPES.DESCRIPTION);
      columnIdsToDisplay.push(DATA_GRID_COLUMN_TYPES.CODE);
      columnIdsToDisplay.push(DATA_GRID_COLUMN_TYPES.GRADE_LEVELS);
      columnIdsToDisplay.push(DATA_GRID_COLUMN_TYPES.TAGS);
      break;
  }
  return columnIdsToDisplay;
};

export const buildSearchFlatTree = ({ nodes, searchText, showDataGridUI }) => {
  if (!showDataGridUI) {
    return buildSearchFlatTreeWithBoldTags({ nodes, searchText });
  }

  // If there's no search text, return all nodes
  if (!searchText) {
    return nodes;
  }

  // Convert search text to lowercase for case-insensitive matching
  const lowerCaseSearchText = _.toLower(searchText);

  // Find nodes matching the search text in label or code
  const matchingNodes = _.filter(nodes, node => {
    const nodeLabel = _.toLower(node.label || "");
    const nodeCode = _.toLower(node.code || "");

    return (
      nodeLabel.includes(lowerCaseSearchText) ||
      nodeCode.includes(lowerCaseSearchText)
    );
  });

  // Get IDs of matching nodes
  const matchingIds = _.map(matchingNodes, node => node.id);

  // Create a map of nodes by ID for easier lookups
  const nodesById = _.keyBy(nodes, "id");

  // Set to store all nodes to be included in result (matching nodes + their ancestors)
  const resultNodeIds = new Set();

  // Add matching nodes and their ancestors to the result set
  _.forEach(matchingIds, id => {
    // Add the matching node
    resultNodeIds.add(id);

    // Add all ancestors
    let currentId = nodesById[id].parent || nodesById[id].parentId;
    while (currentId && nodesById[currentId]) {
      resultNodeIds.add(currentId);
      currentId = nodesById[currentId].parent || nodesById[currentId].parentId;
    }
  });

  // Return only the nodes that should be included in the result
  return _.filter(nodes, node => resultNodeIds.has(node.id));
};
